import type SelectionDropdownFactory from "app/pages/sales-intelligence/sub-modules/table-actions-panel/models/selection-dropdown/SelectionDropdownFactory";

import { LEADS_EXPORT_SELECTION_TOP_N_VALUES } from "../../../constants/websites-table";

import createExportSelectionDropdown from "./factory";

const createLeadGenLeadsSelectionDropdown: SelectionDropdownFactory = createExportSelectionDropdown({
    topNValues: LEADS_EXPORT_SELECTION_TOP_N_VALUES,
});

export default createLeadGenLeadsSelectionDropdown;
